module.exports = {
  ENV: process.env.NODE_ENV || 'dev',
  API_BASE: (process.env.NODE_ENV === 'prod')
    ? 'https://qcs1l2p6hl.execute-api.us-east-1.amazonaws.com/prod/'
      : (process.env.NODE_ENV === 'qa')
        ? 'https://7nkrctw4mc.execute-api.us-east-1.amazonaws.com/qa/'
          : 'https://ttydm7z6d7.execute-api.us-east-1.amazonaws.com/dev/',
  STATUS: {
    DONE: 'DONE',
    ERROR: 'ERROR',
    RUNNING: 'RUNNING',
  }
}


// WEBPACK FOOTER //
// ./src/config.js